import React from 'react';
import addButton from '../../../assets/images/add2.png';
import deleteImage from '../../../assets/images/deleteIcon.png';
import './RewardSection.scss';
import { Image } from 'react-bootstrap';
import { connect } from 'react-redux';
import i18n from '../../../I18n';
import AuthButton from '../../base/AuthButton';
import { useFormContext } from 'react-hook-form';
import { CustomTitleLabel } from '../../earning/CustomBaseComponments';
import {ReactHookFormErrorMessage,} from '../../base/ErrorFieldMessage';
import InputFieldControl from '../../base/InputFieldControl';
import CouponDropdownWithButtonAndPrompt from 'components/earning/CouponDropdownWithButtonAndPrompt';
import ReactHookFormTitleWithRadio from 'components/reactHookFormComponents/ReactHookFormTitleWithRadio';
import ReactHookFormTextInput from 'components/reactHookFormComponents/ReactHookFormTextInput';
import { LanguageConfig } from 'config/CustomEnums';

const RewardType = { coupon: 'COUPON', points: 'POINTS' };
const rewardTypeRadioOptions = [
  { label: 'Coupon', value: RewardType.coupon },
  { label: 'Point', value: RewardType.points },
];

function RewardSection({
  language,
  focusChange = ()=>{},
  onFocus = focusChange, 
}) {
  const { watch, setValue, formState: { errors } } = useFormContext();
  if (language !== LanguageConfig.english) {
    return <></>
  }
  const watchRewards = watch('stampRewards') || [{}];
  const watchTotalStampQuantity = watch('totalStampQuantity') || 0;
  const updateTotalStampQuantity = ({ rewardList = watchRewards }) => {
    let total = 0;
    rewardList.forEach((item) => {
      const stamps = Number(item?.requiredStamps);
      total = stamps > total? stamps: total;
    });
    setValue('totalStampQuantity', total);
  };
  console.log("reward section ", errors)
  const rewardItem = (item, index) => {
    const rewardType = watch(`stampRewards[${index}].rewardType`);
    return (
      <div className="reward-item-container">
        <ReactHookFormTitleWithRadio
          title="Reward type"
          valueFieldName={`stampRewards[${index}].rewardType`}
          defaultValue={RewardType.coupon}
          options={rewardTypeRadioOptions}
          focusChange={onFocus}
          focusKey="rewards"
        />
        {rewardType === RewardType.coupon && (
          <div className="create-section-label-top-space">
            <CouponDropdownWithButtonAndPrompt
              hasAddButton={false}
              title={'Link to coupon set'}
              valueFieldName={`stampRewards[${index}].linkedCoupon`}
              focusChange={onFocus}
              focusKey="rewards"
            />
          </div>
        )}
        <ReactHookFormTextInput 
          title={
            rewardType === RewardType.coupon
              ? 'Coupon quantity'
              : 'Point quantity'
          }
          valueFieldName={`stampRewards[${index}].quantity`}
          type="number"
          focusChange={onFocus}
          focusKey="rewards"       
        />
        <ReactHookFormTextInput
          title={"Required stamps"}
          valueFieldName={`stampRewards[${index}].requiredStamps`}
          type="number"
          focusChange={onFocus}
          focusKey="rewards"
          customClass="margin-botton-section"
          extraActionOnChange={updateTotalStampQuantity}
        />
        {watchRewards?.length > 1 ? (
          <div className="custom-delete-btn-container">
            <AuthButton
              children={
                <Image src={deleteImage} className="custom-delete-btn" />
              }
              customClass="custom-delete-btn"
              action={() => {
                // eslint-disable-next-line array-callback-return
                const newRewardList = watchRewards?.filter((item1, index1) => {
                  // eslint-disable-next-line eqeqeq
                  if (index != index1) {
                    return item1;
                  }
                });
                setValue('stampRewards', newRewardList, { shouldDirty: true });
                if(Number(item.requiredStamps) === watchTotalStampQuantity){
                  updateTotalStampQuantity({ rewardList: newRewardList });
                }
              }}
            />
          </div>
        ) : null}
      </div>
    );
  };

  const addButtonInfo = {
    children: <Image src={addButton} className="add-new-reward-img" />,
    action: () => {
      setValue('stampRewards', [...watchRewards, {}]);
    },
    customClass: 'add-new-reward-button',
  };
  return (
    <>
      <label className="create-section-title">
        {i18n.t('reward', { locale: language })}
      </label>
      {watchRewards?.map((item, index) => rewardItem(item, index))}
      <span id="stampRewardHasError" />
      <ReactHookFormErrorMessage errors={errors} id={'stampRewards'} />
      <CustomTitleLabel title={'Total stamp quantity'} />
      <label>{watchTotalStampQuantity}</label>
      <AuthButton {...addButtonInfo} />
    </>
  );
}

const mapPropsToState = (state) => ({
});

export default connect(mapPropsToState)(RewardSection);
